interface Language {
  code: string
  name: string
  flag: string
}

interface TranslationLanguageSelectorProps {
  label: string
  value: string
  onChange: (languageCode: string) => void
  languages: Language[]
  disabled?: boolean
  className?: string
  placeholder?: string
}

export function TranslationLanguageSelector({ 
  label, 
  value, 
  onChange, 
  languages, 
  disabled = false,
  className = "",
  placeholder
}: TranslationLanguageSelectorProps) {
  return (
    <div className={className}>
      <label className="block text-sm font-medium text-gray-700 mb-3">
        {label}
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="w-full pl-3 pr-8 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
      >
        {placeholder && (
          <option value="">{placeholder}</option>
        )}
        {languages.map((language) => (
          <option key={language.code} value={language.code}>
            {language.flag} {language.name}
          </option>
        ))}
      </select>
    </div>
  )
}